// extracted by mini-css-extract-plugin
export var blue = "_2o-g";
export var brand = "_2o-c";
export var darkGrey = "_2o-f";
export var disabled = "_2o-6";
export var disabledSubtle = "_2o-7";
export var error = "_2o-8";
export var green = "_2o-h";
export var grey = "_2o-e";
export var icon = "_2o-0";
export var inherit = "_2o-b";
export var lightGrey = "_2o-d";
export var orange = "_2o-j";
export var pink = "_2o-l";
export var primary = "_2o-1";
export var purple = "_2o-m";
export var quaternary = "_2o-4";
export var quinary = "_2o-5";
export var red = "_2o-k";
export var secondary = "_2o-2";
export var success = "_2o-a";
export var tertiary = "_2o-3";
export var warning = "_2o-9";
export var white = "_2o-n";
export var yellow = "_2o-i";